import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e23cf258"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bottom-sheet-root"
}
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = ["aria-label", "data-testid"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mx-auto mt-2 h-1 w-10 shrink-0 rounded-full bg-gray-300",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "flex min-h-[48px] shrink-0 items-center gap-1 px-2 pt-1"
}
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { class: "min-w-0 flex-1 px-2 text-left" }
const _hoisted_8 = {
  key: 0,
  class: "truncate text-base font-bold text-gray-900"
}
const _hoisted_9 = {
  key: 1,
  class: "truncate text-xs text-gray-500"
}
const _hoisted_10 = ["data-testid"]
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = ["data-testid"]

import { computed, ref, toRef, useSlots } from 'vue'
import { useOverlayA11y } from '@/composables/useOverlayA11y'

/**
 * Bottom sheet do celular (spec §4.3): puxador, fundo que fecha, Esc, foco preso e rodapé com
 * a área segura do iPhone. A pilha de subtelas (←) é do consumidor: `canGoBack` mostra a seta e
 * `back` avisa o toque.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BottomSheet',
  props: {
    modelValue: { type: Boolean },
    title: { default: undefined },
    subtitle: { default: undefined },
    height: { default: 'auto' },
    canGoBack: { type: Boolean, default: false },
    testId: { default: 'bottom-sheet' },
    ariaLabel: { default: undefined },
    scrimTestId: { default: undefined }
  },
  emits: ["update:modelValue", "back"],
  setup(__props: any, { emit }) {

const props = __props;




const slots = useSlots()
const panel = ref<HTMLElement | null>(null)

// O Tailwind só vale dentro de #app (`important: '#app'`). Sem #app (jsdom), renderiza no lugar.
// O Vue 3.3 resolve o `to` mesmo com o Teleport desabilitado; `body` sempre existe e evita o aviso.
const hasAppTarget = typeof document !== 'undefined' && !!document.getElementById('app')

const hasHeader = computed(
  () => !!props.title || !!props.subtitle || props.canGoBack || !!slots['header-actions']
)

function close(): void {
  emit('update:modelValue', false)
}

const { onPanelKeydown } = useOverlayA11y({
  panel,
  isOpen: toRef(props, 'modelValue'),
  onEscape: close
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, {
    to: _unref(hasAppTarget) ? '#app' : 'body',
    disabled: !_unref(hasAppTarget)
  }, [
    _createVNode(_Transition, { name: "bottom-sheet" }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "fixed inset-0 z-40 bg-black/40",
                "aria-hidden": "true",
                "data-testid": _ctx.scrimTestId ?? `${_ctx.testId}-scrim`,
                onClick: close
              }, null, 8, _hoisted_2),
              _createElementVNode("section", {
                ref_key: "panel",
                ref: panel,
                class: _normalizeClass(["bottom-sheet-panel fixed inset-x-0 bottom-0 z-50 flex flex-col rounded-t-2xl bg-white pb-0 shadow-2xl outline-none", _ctx.height === 'tall' ? 'bottom-sheet-panel--tall' : 'bottom-sheet-panel--auto']),
                role: "dialog",
                "aria-modal": "true",
                "aria-label": _ctx.ariaLabel ?? _ctx.title,
                tabindex: "-1",
                "data-testid": _ctx.testId,
                onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onPanelKeydown) && _unref(onPanelKeydown)(...args)))
              }, [
                _hoisted_4,
                (hasHeader.value)
                  ? (_openBlock(), _createElementBlock("header", _hoisted_5, [
                      (_ctx.canGoBack)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-lg text-gray-700",
                            "aria-label": "Voltar",
                            "data-testid": `${_ctx.testId}-back`,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
                          }, " ← ", 8, _hoisted_6))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, [
                        (_ctx.title)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(_ctx.title), 1))
                          : _createCommentVNode("", true),
                        (_ctx.subtitle)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.subtitle), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _renderSlot(_ctx.$slots, "header-actions"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-gray-500",
                        "aria-label": "Fechar",
                        "data-testid": `${_ctx.testId}-close`,
                        onClick: close
                      }, " ✕ ", 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "min-h-0 flex-1 overflow-y-auto overscroll-contain px-4",
                  "data-testid": `${_ctx.testId}-body`
                }, [
                  _renderSlot(_ctx.$slots, "default")
                ], 8, _hoisted_11),
                (_ctx.$slots.footer)
                  ? (_openBlock(), _createElementBlock("footer", {
                      key: 1,
                      class: "shrink-0 border-t border-gray-100 bg-white px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))]",
                      "data-testid": `${_ctx.testId}-footer`
                    }, [
                      _renderSlot(_ctx.$slots, "footer")
                    ], 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 8, ["to", "disabled"]))
}
}

})